import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import styles from './styles.module.scss'

export default function ProfileActivity() {
  const { t } = useTranslation()

  const { profileData } = useSelector((state) => state.myProfile)

  return (
    <div className={`${styles.profileActivity}`}>
      {profileData.user_activity && (
        <h2 className={`${styles.activityTitle}`}>
          {profileData.editable === 0
            ? `${t('my_profile.activity.userActivity', {
                orgName: profileData.user_activity.organization_name,
                username: profileData.user.first_name
              })}`
            : `${t('my_profile.activity.myActivity', { orgName: profileData.user_activity.organization_name })}`}
        </h2>
      )}
      <div className={`${styles.activityWrap}`}>
        {profileData.user_activity.groups_created ? (
          <div className={`${styles.countBox}`}>
            <h2 className={`${styles.count}`}>{profileData.user_activity.groups_created}</h2>
            <h2 className={`${styles.countTitle}`}>{t('my_profile.activity.countTitle1')}</h2>
          </div>
        ) : (
          ''
        )}
        {profileData.user_activity.mixrs_created ? (
          <div className={`${styles.countBox}`}>
            <h2 className={`${styles.count}`}>{profileData.user_activity.mixrs_created}</h2>
            <h2 className={`${styles.countTitle}`}>{t('my_profile.activity.countTitle2')}</h2>
          </div>
        ) : (
          ''
        )}
        {profileData.user_activity.groups_joined ? (
          <div className={`${styles.countBox}`}>
            <h2 className={`${styles.count}`}>{profileData.user_activity.groups_joined}</h2>
            <h2 className={`${styles.countTitle}`}>{t('my_profile.activity.countTitle3')}</h2>
          </div>
        ) : (
          ''
        )}
        {profileData.user_activity.mixrs_attended ? (
          <div className={`${styles.countBox}`}>
            <h2 className={`${styles.count}`}>{profileData.user_activity.mixrs_attended}</h2>
            <h2 className={`${styles.countTitle}`}>{t('my_profile.activity.countTitle4')}</h2>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}
